import BuildingBlocksTabsComponent from "./building-blocks-tabs-component";
import BuildingBlocksTabsConfig from "./building-blocks-tabs-config";
import BuildingBlocksTabsAdvancedConfig from "./building-blocks-tabs-advanced-config";

export default {
  BuildingBlocksTabsComponent,
  BuildingBlocksTabsConfig,
  BuildingBlocksTabsAdvancedConfig
};
